
namespace RioERP.Masters {
    export class BooksColumns {
        static columnsKey = 'Masters.Books';
    }
}